import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

// Styling
import styles from './styles';

// Button
import Button from 'material-ui/Button';

class GetStartedButton extends Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  onGetStarted() {
    /*if (window.location.href.includes("?opened")){
      window.history.go(-1);
    }*/

    const { cookies } = this.props;

    if (cookies.get('last_href')){
      if (cookies.get('last_href').length > 1) {
        window.location.href = cookies.get('last_href');
      }
    } else {
      this.props.changeRoute('/console/display/rapid_display_view');
    }
  }

  render(){
    const { classes } = this.props;
    return(
        <Button className={classes.root} onClick={() => {this.onGetStarted()}} raised color="primary">Get Started</Button>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number, 
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router,
        last_url: state.markSpot.last_url,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

GetStartedButton.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withCookies(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(GetStartedButton)));



// WEBPACK FOOTER //
// ./src/scenes/GetStarted/components/GetStartedButton/index.js